import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingsComponent } from './settings.component';
import { AdminAuthGuard } from './auth.guard';
import { CalculationsComponent } from './calculations/calculations.component';
import { CalculationComponent } from './calculations/calculation/calculation.component';
import { TaxReturnBuilderSelectorComponent } from './tax-return-builder/tax-return-builder-selector/tax-return-builder-selector.component';
import { TaxReturnBuilderComponent } from './tax-return-builder/tax-return-builder.component';
import { QuestionsComponent } from './questions/questions.component';
import { QuestionComponent } from './questions/question/question.component';
import { QuestionsResolver } from './questions/questions-resolver';
import { TaxYearsComponent } from './tax-years/tax-years.component';
import { TaxReturnTypesComponent } from './tax-return-types/tax-return-types.component';
import { TaxReturnSubTypesComponent } from './tax-return-types/tax-return-subtypes/tax-return-subtypes.component';
import { ClientRulesQuestionsComponent } from './client-rules/questions/client-rules-questions.component';
import { ClientRulesQuestionComponent } from './client-rules/questions/question/client-rules-question.component';
import { ClientRulesQuestionsResolver } from './client-rules/questions/client-rules-questions-resolver';
import { ClientRulesBuilderYearSelectComponent } from './client-rules/client-rules-builder/year-select/client-rules-builder-year-select.component';
import { ClientRulesBuilderComponent } from './client-rules/client-rules-builder/client-rules-builder.component';
import { SourcesComponent } from './sources/sources.component';
import { SourceComponent } from './sources/source/source.component';
import { TemplatesComponent } from './templates/templates.component';
import { GlobalBuilderComponent } from './global/builder/global-builder.component';
import { GlobalQuestionComponent } from './global/questions/question/global-question.component';
import { GlobalQuestionsResolver } from './global/questions/global-questions-resolver';
import { GlobalQuestionsComponent } from './global/questions/global-questions.component';
import { CountriesComponent } from './countries/countries.component';
import { UsersComponent } from './users/users.component';
import { ConfigImportComponent } from './config-import/config-import.component';
import { SmartFormTypesComponent } from './smart-forms/types/smart-form-types.component';
import { SmartFormSelectComponent } from './smart-forms/smart-form-select/smart-form-select.component';
import { SmartFormBuilderComponent } from './smart-forms/smart-form-builder.component';
import { AtlasImportComponent } from './atlas-import/atlas-import.component';
import { ArchivedConfigsComponent } from './archived-configs/archived-configs.component';


const settingsRoutes: Routes = [
  {
    path: "settings",
    component: SettingsComponent,
    data: {
      hideSidebar: true, // the <app-sidebar>
      hideSettingsSidebar: false,
    },
    canActivate: [AdminAuthGuard],
    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: "questions",
      },
      {
        path: "calculations",
        children: [
          {
            path: "",
            component: CalculationsComponent,
            data: {
              hideSettingsSidebar: false,
            },
          },
          {
            path: ":id",
            component: CalculationComponent,
            data: {
              hideSettingsSidebar: true,
            },
          },
        ],
      },
      {
        path: "form",
        children: [
          {
            path: "builder-year-select",
            component: TaxReturnBuilderSelectorComponent,
            data: {
              hideSettingsSidebar: false,
            },
          },
          {
            path: "builder",
            component: TaxReturnBuilderComponent,
            data: {
              hideSettingsSidebar: true,
            },
          },
        ],
      },

      {
        path: "questions",
        children: [
          {
            path: "",
            component: QuestionsComponent,
            data: {
              hideSettingsSidebar: false,
            },
          },
          {
            path: ":id",
            component: QuestionComponent,
            data: {
              hideSettingsSidebar: true,
            },
            resolve: {
              question: QuestionsResolver,
            },
          },
        ],
      },
      {
        path: "tax-years",
        component: TaxYearsComponent,
        data: {
          hideSidebar: true,
          hideSettingsSidebar: false,
        },
      },
      {
        path: "types",
        children: [
          {
            path: "",
            component: TaxReturnTypesComponent,
            data: {
              hideSidebar: true,
              hideSettingsSidebar: false,
            },
          },
          {
            path: ":typeId/subtypes",
            component: TaxReturnSubTypesComponent,
            data: {
              hideSidebar: true,
              hideSettingsSidebar: false,
            },
          },
        ],
      },
      {
        path: "client-rules",
        children: [
          {
            path: "questions",
            children: [
              {
                path: "",
                component: ClientRulesQuestionsComponent,
                data: {
                  hideSettingsSidebar: false,
                },
              },
              {
                path: ":id",
                component: ClientRulesQuestionComponent,
                data: {
                  hideSettingsSidebar: true,
                },
                resolve: {
                  question: ClientRulesQuestionsResolver,
                },
              },
            ],
          },
        ],
      },
      {
        path: "client-rules",
        children: [
          {
            path: "builder-year-select",
            children: [
              {
                path: "",
                component: ClientRulesBuilderYearSelectComponent,
                data: {
                  hideSettingsSidebar: false,
                },
              },
            ],
          },
          {
            path: "builder",
            children: [
              {
                path: "",
                component: ClientRulesBuilderComponent,
                data: {
                  hideSettingsSidebar: true,
                },
              },
            ],
          },
        ],
      },
      {
        path: "global",
        children: [
          {
            path: "questions",
            children: [
              {
                path: "",
                component: GlobalQuestionsComponent,
                data: {
                  hideSettingsSidebar: false,
                },
              },
              {
                path: ":id",
                component: GlobalQuestionComponent,
                data: {
                  hideSettingsSidebar: true,
                },
                resolve: {
                  question: GlobalQuestionsResolver,
                },
              },
            ],
          },
        ],
      },
      {
        path: "global",
        children: [
          {
            path: "builder",
            children: [
              {
                path: "",
                component: GlobalBuilderComponent,
                data: {
                  hideSettingsSidebar: true,
                },
              },
            ],
          },
        ],
      },
      {
        path: "sources",
        children: [
          {
            path: "",
            component: SourcesComponent,
            data: {
              hideSettingsSidebar: false,
            },
          },
          {
            path: ":id",
            component: SourceComponent,
            data: {
              hideSettingsSidebar: false,
            },
          },
        ],
      },
      {
        path: "templates",
        children: [
          {
            path: "",
            component: TemplatesComponent,
            data: {
              hideSettingsSidebar: false,
            },
          },
        ],
      },
      {
        path: "countries",
        children: [
          {
            path: "",
            component: CountriesComponent,
            data: {
              hideSettingsSidebar: false,
            },
          },
        ],
      },
      {
        path: "users",
        children: [
          {
            path: "",
            component: UsersComponent,
            data: {
              hideSettingsSidebar: false,
            },
          },
        ],
      },
      {
        path: "countries",
        children: [
          {
            path: "",
            component: CountriesComponent,
            data: {
              hideSettingsSidebar: false,
            },
          },
        ],
      },

      {
        path: "users",
        children: [
          {
            path: "",
            component: UsersComponent,
            data: {
              hideSettingsSidebar: false,
            },
          },
        ],
      },

      {
        path: "config-import",
        children: [
          {
            path: "",
            component: ConfigImportComponent,
            data: {
              hideSettingsSidebar: false,
            }
          }
        ]
      },

      {
        path: "smartFormTypes",
        component: SmartFormTypesComponent,
        data: {
          hideSidebar: true,
          hideSettingsSidebar: false,
        },
      },
      {
        path: "smartForm",
        children: [
          {
            path: "builder-year-select",
            component: SmartFormSelectComponent,
            data: {
              hideSettingsSidebar: false,
            },
          },
          {
            path: "builder",
            component: SmartFormBuilderComponent,
            data: {
              hideSettingsSidebar: true,
              hideSidebar: false,
            },
          },
        ],
      },

      {
        path: "atlas-import",
        children: [
          {
            path: "",
            component: AtlasImportComponent,
            data: {
              hideSettngsSidebar: false,
            }
          }
        ]
      },

      {
        path: "archived-configs",
        children: [
          {
            path: "",
            component: ArchivedConfigsComponent,
            data: {
              hideSettingsSidebar: false,
            }
          }
        ]
      }
    ],
  },
];


@NgModule({
  imports: [RouterModule.forRoot(settingsRoutes, {})],
  exports: [RouterModule]
})
export class SettingsRoutingModule { }
